import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios, { Axios } from 'axios';
import './PaymentPage.css';
import Spinner from './components/Spinner';
function ResultPage() {
    const location = useLocation();
    const navigate = useNavigate();

    const { product, paymentStatus, phoneNumber , error } = location.state || {};
        const handleGoToHome = () => {
        navigate('/');
    };
    useEffect(() => {
        if (!product || !paymentStatus) {
            navigate('/');
        }
    }, [product, paymentStatus, navigate]);
    console.log('ResultPage location state:', location.state);
     return (
        <div className="payment-container" dir="rtl">
            <div className="payment-card">
                <h2>معالجة الدفع</h2>
                
                {paymentStatus === 'success' && (
                    <div className="payment-success">
                        <div className="success-icon">✓</div>
                        <h3>تم الدفع بنجاح!</h3>
                        <p>تم اكتمال عملية الشحن للرقم {phoneNumber}.</p>
                        <p className="product-info">
                            {product.productName} - {product.finalPrice} درهم
                        </p>
                        <button 
                            className="payment-button back-button"
                            onClick={handleGoToHome}
                        >
                            العودة إلى الصفحة الرئيسية
                        </button>
                    </div>
                )}
                
                {paymentStatus === 'failed' && (
                    <div className="payment-failed">
                        <div className="failed-icon">✕</div>
                        <h3>فشلت عملية الدفع</h3>
                        <p>{error}</p>
                        <div className="button-group">
                        <button 
                            className="payment-button back-button"
                            onClick={handleGoToHome}
                        >
                            العودة إلى الصفحة الرئيسية
                        </button>
                        </div>
                    </div>
                )}
                
                {!paymentStatus && (
                    <div className="payment-initializing">
                        <p>جاري بدء عملية الدفع...</p>
                    </div>
                )}
            </div>
        </div>
    );

};
export default ResultPage;